import PortalIdParser from 'PortalIdParser';
export const TEAM_PREFIX = 'team:';
export const TAG_ERROR = 'error';
export const USER_TEAMS_HREF = `/settings/${PortalIdParser.get()}/users`;